const state = {
  info: {},
}

const getters = {
}

const mutations = {
  setInfo (state, v) {
    state.info = v
  },
}

const actions = {
  info ({ state, commit, rootState }, params) {
    return rootState.axios.get('/review/v1frontend/review-user/info', { params }).then(res => {
      commit('setInfo', res.data.model)
      return res
    })
  },
  uploadBackimage ({ state, commit, rootState }, params) {
    return rootState.axios.post('/review/v1frontend/review-record/upload-backimage', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
